import script from "./UiTableTd.vue?vue&type=script&setup=true&lang=js"
export * from "./UiTableTd.vue?vue&type=script&setup=true&lang=js"

import "./UiTableTd.vue?vue&type=style&index=0&id=0fec8e35&lang=scss"

const __exports__ = script;

export default __exports__